import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Chip from "@mui/material/Chip";
function RenderCellName({ row, column, }) {
    const value = row[column.field];
    if (!row.groupId) {
        return _jsx(_Fragment, { children: value });
    }
    return (_jsxs(_Fragment, { children: [_jsx(Chip, { label: row.groupId, size: "small", sx: { marginRight: "1rem" } }), value] }));
}
export default RenderCellName;
//# sourceMappingURL=RenderCellName.js.map